<template lang="html">
  <div class="__loading">
    <v-overlay :value="overlay" color="white">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      overlay: true,
      url_id: '',
      form: {
        item: []
      }
    }
  },
  mounted() {
    this.goToTakeaway()
  },
  methods: {
    async goToTakeaway() {
      this.$store.dispatch('set_qrmode', true)
      this.$store.dispatch('saveSelectedType', 'OL-TAKE-AWAY')
      this.$store.dispatch('saveDataCartTakeAway', this.form)
      const obj = {
        url_id: this.$route.params.url_id,
        id: this.$route.params.store_id
      }
      const url_id = this.$store.state.selected_outlet.url_id
      const store_id = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id'))
      if (url_id !== this.$route.params.url_id || store_id !== Number(this.$route.params.store_id)) {
        await this.$store.dispatch('fetchOutlet', obj)
      }
      this.$router.push({ name: 'take_away' }).catch(() => {})
    }
  }
}
</script>
